module.exports = __webpack_public_path__ + "static/03-39d09ec471a6823cf2aae132fb95389d.jpg";